$(() => {

    var token = '';

    $(".cliente-login").off();
    $(".cliente-login").on('click', function(e) {
        checkLogin();
    });  
    
    $(".cliente-logout").off();
    $(".cliente-logout").on('click', function(e) {
        logout();
    }); 
    
    $(".cliente-resetsend").off();
    $(".cliente-resetsend").on('click', function(e) {
        resetSend();
    }); 
    
    $(".cliente-token").off();
    $(".cliente-token").on('click', function(e) {
        checkToken();
    });
    
    $(".cliente-alterarsenha").off();
    $(".cliente-alterarsenha").on('click', function(e) {
        changePassword();
    });

    var loading = false;

    var showDataLoader = function(){

		$("#placa-details").html("<div id='publicacoes-data-loader' style='padding: 20px 0px 0px 300px' ><img src='/imgs/window-component-loader.gif' /></div>")

	}

    $("#c-f-email").focus();
    $("#c-f-email, #c-f-senha").keypress(function(e){
    	if((e.wich == 13 || e.keyCode == 13) && !loading)
        	$(".cliente-login").click();

    });

    $(".item-placa").off();
    $(".item-placa").on("click", function() {

        let data = {
            placa: $(this).attr('ref')
        };

        let config = {
            data: data
        }

        showDataLoader();
        $('.item-placa').prop("disabled", true);
        $.post('/cliente/details', config, function(r) {
            $("#placa-details").html(r);
            $('.item-placa').prop("disabled", false);
        });
    })

    //modal nova placa

    $(".c-n-b-placa").off();
    $(".c-n-b-placa").on('click', function() {
        $("#placaModal").modal('show');
    });

    $('.c-n-p-placa').mask('AAA-0000');

    $(".c-n-p-close").off();
    $(".c-n-p-close").on('click', function() {
        $("#placaModal").modal('hide');
    });  
    
    $(".c-n-p-send").off();
    $(".c-n-p-send").on('click', function() {
        insertPlaca();
    });

    $("input[name='tipoRadioOptions']").off();
    $("input[name='tipoRadioOptions']").on('click', function() {
        switch ($("input[name='tipoRadioOptions']:checked").val()) {
            case "0":
                $('.c-n-p-placa').mask('AAA-0000');
                break;
            case "1":
                $('.c-n-p-placa').mask('AAA0S00');
                break;
        }
    });

    $(document).off();
    $(document).on('click', '.n-d-b-a-print', function() {
        window.location = "/cupom/index/chave/" + $(this).attr('chave');
	});

    function insertPlaca() {
        if($(".c-n-p-placa").val() != ""){
            data = {
                placa: $(".c-n-p-placa").val(),
                tipo: $("input[name='tipoRadioOptions']:checked").val()
            }

            let config = {
                data: data
            };

            $('.c-n-p-send').prop("disabled", true);

            $.post('/cliente/insertplaca', config, function(r) {
                    if (r.response) {
                        $('.message').text("Enviado com sucesso, aguarde a aprovação!");
                        setTimeout(() => {
                            $(".c-n-p-placa").val('');
                            $(".c-n-p-send").button('reset');
                            $('.message').text("");
                            $("#placaModal").modal('hide');
                            $('.c-n-p-send').prop("disabled", false);
                        }, 2000);
                    } else {
                        error('show', r.error);
                        setTimeout(() => {
                            $('.c-n-p-send').prop("disabled", false);
                        }, 2000);
                    }
                },
                'json'
		    );
        $('.c-n-p-send').prop("disabled", true);
        }else{
            error('show', "Placa inválida, verifique e tente novamente!");
        }
    }

    function checkLogin() {
        let data = {
            login: $(".c-f-email").val(),
            passwd: $(".c-f-senha").val()
        }

		if(data.login && data.passwd)
		{

            let config = {
                data: data
            };

            $('.cliente-login').prop("disabled", true);
            $.post(
                '/cliente/checklogin',
                config,
                function(r) {
    
                    loading = false;

                    if (r.response) {
                        $("#logadoModal").modal('show');
                        setTimeout(() => {
                            window.location.href = "/cliente";
                        }, 1000);
                    } else {
                        error('show', r.error)
                        setTimeout(() => {
                            $('.cliente-login').prop("disabled", false);
                        }, 2000);
                    }
                },
                'json'
            );
            $('.cliente-login').prop("disabled", true);
		}
		else
		{
            error();
		}
		
	}

    function logout() {
        let config = {

        }
        $('.cliente-logout').prop("disabled", true);
        $.post(
            '/cliente/logout', 
            config,
            function(r) {
                // $('.requerimento-submit').prop('disabled', function() {
                // 	return !$(this).prop('disabled');
                // });

                if (r.response) {
                    window.location.href = "/cliente";
                } else {
                    error('show', r.response)
                    $('.cliente-logout').prop("disabled", false);
                }
            },
            'json'
        );
        $('.cliente-logout').prop("disabled", true);
	}

    function resetSend() {
   
        let data = {
            email: $(".email").val(),
        }
       
		if(data.email) {
            let config = {
                data: data
            };

            $('.cliente-resetsend').prop("disabled", true);
            $.post(
                '/cliente/resetsend',
                config,
                function(r) {
                    if (r.response) {
                        $('.message').text("Enviado com sucesso!");
                        setTimeout(() => {
                            window.location.href = "/cliente/token";
                            $('.cliente-resetsend').prop("disabled", false);
                        }, 1000);
                    } else {
                        error('show', r.error)
                        setTimeout(() => {
                            $('.cliente-resetsend').prop("disabled", false);
                        }, 2000);
                    }
                },
                'json'
            );
            $('.cliente-resetsend').prop("disabled", true);
		}
		else{
            error("show", "Email incorreto!");
		}
		
    }

    function checkToken() {

   
        let data = {
            token: $(".token").val(),
        }
    
		if(data.token) {
            let config = {
                data: data
            };

            $('.cliente-token').prop("disabled", true);
            $.post(
                '/cliente/checktoken',
                config,
                function(r) {
                    if (r.response) {
                        token = r.token
                        window.location.href = "/cliente/alterarsenha/" + r.token;
                    } else {
                        error('show', r.error)
                        setTimeout(() => {
                            $('.cliente-token').prop("disabled", false);
                        }, 2000);
                    }
                },
                'json'
            );
            $('.cliente-token').prop("disabled", true);
		}
		else{
            error("show", "Código invalido!");
		}
		
    }

    function changePassword() {
        let senha = $(".r-senha").val();
      
        if(senha.length < 6) {
            error('show', `Senha muito curta! Precisa ter mais de 6 caracteres.`);
            ok = false;
        }

        if($('.r-senha').val() != $('.r-confirmarsenha').val()){
            error('show', `As senhas não coincidem!`);
            ok = false;
        }

        let data = {
            senha: senha,
        }
 
		if(data.senha) {
            let config = {
                data: data
            };

            $('.cliente-token').prop("disabled", true);
            $.post(
                '/cliente/resetpassword' + token,
                config,
                function(r) {
                    if (r.response) {
                        window.location.href = "/cliente";
                    } else {
                        error('show', r.error)
                        setTimeout(() => {
                            $('.cliente-token').prop("disabled", false);
                        }, 2000);
                    }
                },
                'json'
            );
            $('.cliente-token').prop("disabled", true);
		}
		else{
            error("show", "senha invalida!");
		}
    }

    function error(mode = 'show', message = 'Por favor, preencha todos os campos corretamente!', element = null) {
		$('.login-error').text(message);
        $('.error').text(message);

		if (mode === 'show') {
			if (element) {
				$([ document.documentElement, document.body ]).animate(
					{
						scrollTop: element.offset().top - 200
					},
					1
				);
				element.addClass('border border-danger');
				setTimeout(() => {
					element.removeClass('border border-danger');
				}, 5000);
			}
			$('.error').fadeIn();
			$('.cliente-submit').prop('disabled', function() {
				return !$(this).prop('disabled');
			});
			setTimeout(() => {
				$('.error').fadeOut();
				$('.cliente-submit').prop('disabled', function() {
					return !$(this).prop('disabled');
				});
			}, 1000);
			return false;
		} else if (mode === 'hide') {
			$('.error').hide();
		}
	}

})